module.exports = __webpack_public_path__ + "img/sydneystone2.48459117.jpg";